import { useEffect, useRef } from 'react';

import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Render from 'components/render';
import { IS_DEMO } from 'constants/constants';
import { SHOW_DELTA_GLOBAL_BANK_WITHDRAWAL_PAGE } from 'constants/featureFlag';
import routes from 'constants/routes';
import {
  isUserIndianSelector,
  selectUserPermissionsForBankWithdrawalEnabled,
} from 'selectors/otherSelectors';
import { useAppSelector } from 'storeHooks';
import Box from 'UIKit/Box';
import DeltaButton from 'UIKit/DeltaButton';

import commonStyles from './accountHeaderPartials.module.scss';

const WithdrawalMobileHeader = ({ pathname }: { pathname: string }) => {
  const { t } = useTranslation(['account', 'common']);

  const indianUser = useAppSelector(isUserIndianSelector);

  const bankWithdrawalEnabled = useAppSelector(
    selectUserPermissionsForBankWithdrawalEnabled
  );

  const containerRef = useRef(null);
  const tab1Ref = useRef(null);
  const tab2Ref = useRef(null);

  const scrollToTab = tabRef => {
    if (tabRef && containerRef.current) {
      // Calculate the scroll position to scroll to the tab
      const tabPosition = tabRef.current.offsetLeft;
      // Scroll the div to the position of the tab
      containerRef.current.scrollLeft = tabPosition;
    }
  };

  const isLastTabActive =
    pathname.includes(routes.account.withdrawal) &&
    !pathname.includes(routes.account.withdrawalBank);

  // when user lands directly to tab2 scroll should happend
  useEffect(() => {
    if (isLastTabActive) {
      scrollToTab(tab2Ref);
    }
  }, [isLastTabActive]);

  const showWithdrawToBank =
    !IS_DEMO&&
    indianUser &&
    bankWithdrawalEnabled &&
    SHOW_DELTA_GLOBAL_BANK_WITHDRAWAL_PAGE;

  const depositTabsClassNames = cx('header-text', 'deposit-tabs', {
    'deposit-tabs-scrollable': isLastTabActive,
  });

  return (
    <Box className={depositTabsClassNames} ref={containerRef}>
      <DeltaButton
        role="button"
        useBasicButton
        data-testid="withdraw-tab-mobile"
        as={Link}
        to={routes.account.withdrawal}
        replace
        className={cx(
          'tab',
          ' deposit',
          {
            active:
              pathname.includes(routes.account.withdrawal) &&
              !pathname.includes(routes.account.withdrawalBank),
          },
          commonStyles.order2
        )}
        onClick={() => scrollToTab(tab2Ref)}
        ref={tab2Ref}
      >
        {indianUser ? t('account:withdrawCrypto') : t('account:withdraw')}
      </DeltaButton>
      <Render when={showWithdrawToBank}>
        <DeltaButton
          role="button"
          useBasicButton
          data-testid="withdraw-bank-tab-mobile"
          as={Link}
          to={routes.account.withdrawalBank}
          replace
          className={cx(
            'tab',
            'buyCrypto',
            {
              active: pathname.includes(routes.account.withdrawalBank),
            },
            commonStyles.order1
          )}
          onClick={() => scrollToTab(tab1Ref)}
          ref={tab1Ref}
        >
          {t('account:withdrawToBank')}
        </DeltaButton>
      </Render>
    </Box>
  );
};

export default WithdrawalMobileHeader;
